export enum eTypeAlert {
  Alert = 1,
  Incidence = 2,
  External = 3
}
